import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from 'src/components/dialogue/radix-dialog';

function Section({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <div className="rounded-lg border bg-muted/30 p-4 space-y-3">
      <h3 className="text-sm font-semibold uppercase tracking-wide text-muted-foreground">
        {title}
      </h3>
      <div className="space-y-2">{children}</div>
    </div>
  );
}

function Detail({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex justify-between gap-4 text-sm">
      <span className="text-muted-foreground">{label}</span>
      <span className="font-medium text-right break-all">{value}</span>
    </div>
  );
}


export const ViewCandidateDetailDialog = ({children, candidate}) => {
  return (
    <Dialog>
      <DialogTrigger>{children}</DialogTrigger>
      <DialogContent className="bg-white max-w-2xl max-h-[80vh] overflow-y-auto">
        <DialogHeader className="border-b pb-4">
          <DialogTitle className="text-center text-xl font-semibold tracking-wide uppercase">
            {candidate.name}
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-6 pt-4">
          {/* Personal Info */}
          <Section title="Personal Information">
            <Detail label="Email" value={candidate.email} />
            <Detail label="Phone Number" value={candidate.phone_number} />
            {candidate.whatsapp_number && (
              <Detail
                label="WhatsApp Number"
                value={candidate.whatsapp_number}
              />
            )}
          </Section>

          {/* Education */}
          <Section title="Education">
            <Detail
              label="Education Qualification"
              value={candidate.education_qualification}
            />
            <Detail
              label="Other Qualification"
              value={candidate.other_qualification || "—"}
            />
          </Section>

          {/* Location */}
          <Section title="Location">
            <Detail label="State" value={candidate.state} />
            <Detail label="District" value={candidate.district} />
            <Detail label="City" value={candidate.city} />
            <Detail label="PIN Code" value={candidate.pin} />
          </Section>

          {/* Payment */}
          <Section title="Payment Details">
            <Detail label="Transaction ID" value={candidate.transaction_id} />
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">
                Payment Status
              </span>
              <span
                className={`px-3 py-1 rounded-full text-xs font-medium ${
                  candidate.paid
                    ? "bg-green-100 text-green-700"
                    : "bg-red-100 text-red-700"
                }`}
              >
                {candidate.paid ? "Paid" : "Unpaid"}
              </span>
            </div>
          </Section>

          {/* Meta */}
          <Section title="Metadata">
            <Detail
              label="Created At"
              value={new Date(candidate.created_at).toLocaleString()}
            />
            <Detail
              label="Last Updated"
              value={new Date(candidate.updated_at).toLocaleString()}
            />
          </Section>
        </div>
      </DialogContent>
    </Dialog>
  );
}
